import { useQuery, useMutation } from 'react-query';
import { useClient } from '../../../../api/api-client';

export function useGetAnnouncements(
  queryConfig = {},
  offset = 0,
  limit = 5,
  role_ids = [],
) {
  const client = useClient();
  return useQuery({
    queryKey: ['announcements', offset, limit],
    queryFn: () =>
      client(
        `announcements/fetch?offset=${offset}&limit=${limit}&role_ids=${role_ids}`,
      ),
    ...queryConfig,
  });
}

export function useCreateAnnouncements(mutationConfig) {
  const client = useClient();

  return useMutation((data) => client('announcements/create', { data }), {
    mutationKey: ['announcements'],
    ...mutationConfig,
  });
}

export function useUpdateAnnouncements(mutationConfig) {
  const client = useClient();

  return useMutation({
    mutationKey: [],
    mutationFn: (data) => {
      return client(`announcements/update`, {
        method: 'PUT',
        data: data,
      });
    },
    ...mutationConfig,
    cacheTime: 0,
  });
}
